import './systemError.scss';
import React, { PureComponent } from 'react';
import { Link } from 'react-router';

export default class SystemError extends PureComponent {
    render() {
        return (
            <div className="system-error">
                <Link to="/">返回首页</Link>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/common/error/systemError/SystemError.jsx